import CollabToolbar from "./CollabToolbar";
import { PartnerCatalog } from "./PartnerCatalog";
import { GateIntro } from "./GateIntro";
import { CdaCallout } from "./CdaCallout";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL || "";

function slugFromPath() {
  try {
    const parts = window.location.pathname.split("/").filter(Boolean);
    return parts[parts.length - 1] || "form";
  } catch (e) {
    return "form";
  }
}

function domainOf(email) {
  const e = (email || "").trim().toLowerCase();
  return e.indexOf("@") > 0 ? e.split("@")[1] : "";
}

function validEmail(email) {
  const e = (email || "").trim();
  const at = e.indexOf("@");
  return at > 0 && e.slice(at + 1).indexOf(".") > 0;
}

async function verifyCode(code) {
  try {
    const r = await fetch(API + "/api/verify-access", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: code }),
    });
    const d = await r.json();
    return !!(d && d.valid);
  } catch (e) {
    return false;
  }
}

export function FormGate({ children }) {
  const [ok, setOk] = useState(false);
  const [checking, setChecking] = useState(false);
  const [sent, setSent] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const [code, setCode] = useState("");
  const [codeErr, setCodeErr] = useState(false);
  const [codeBusy, setCodeBusy] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", email: "", need: "", hp: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  // collaborative draft state
  const [draftId, setDraftId] = useState("");
  const [draftToken, setDraftToken] = useState("");
  const [joinNeeded, setJoinNeeded] = useState(false);
  const [joinForm, setJoinForm] = useState({ name: "", email: "" });
  const [joinErr, setJoinErr] = useState("");
  const [joinBusy, setJoinBusy] = useState(false);
  const [me, setMe] = useState(null);
  const [draft, setDraft] = useState(null);
  const [shareUrl, setShareUrl] = useState("");
  const [showShare, setShowShare] = useState(false);
  const [initForm, setInitForm] = useState({ name: "", email: "" });
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteMsg, setInviteMsg] = useState("");
  const [copyMsg, setCopyMsg] = useState("");

  const boxRef = useRef(null);
  const draftRef = useRef({ id: "", token: "" });

  function unlock() {
    setOk(true);
    try {
      window.sessionStorage.setItem("lamko_form_access", "1");
    } catch (e) {}
  }

  useEffect(() => {
    let active = true;
    let params = new URLSearchParams("");
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {}
    const d = params.get("draft") || "";
    const tk = params.get("t") || "";
    if (d && tk) {
      setDraftId(d);
      setDraftToken(tk);
      draftRef.current = { id: d, token: tk };
      setJoinNeeded(true);
      return () => {
        active = false;
      };
    }
    try {
      if (window.sessionStorage.getItem("lamko_form_access") === "1") {
        setOk(true);
        return;
      }
    } catch (e) {}
    const param = params.get("access") || "";
    if (param) {
      setChecking(true);
      verifyCode(param).then((valid) => {
        if (!active) return;
        setChecking(false);
        if (valid) unlock();
      });
    }
    return () => {
      active = false;
    };
  }, []);

  function collectNow() {
    const root = boxRef.current;
    const data = {};
    if (!root) return data;
    root.querySelectorAll("input, select, textarea").forEach((el, i) => {
      const t = (el.type || "").toLowerCase();
      if (
        t === "file" ||
        t === "password" ||
        t === "hidden" ||
        t === "submit" ||
        t === "button" ||
        el.getAttribute("aria-hidden") === "true"
      )
        return;
      const k = el.id || el.name || "f" + i;
      if (t === "checkbox" || t === "radio") data[k] = el.checked;
      else data[k] = el.value;
    });
    return data;
  }

  // Auto-save: to server draft when in draft mode, else to localStorage.
  useEffect(() => {
    if (!ok) return;
    const root = boxRef.current;
    if (!root) return;
    const KEY = "lamko_draft_" + window.location.pathname;
    const SEL = "input, select, textarea";
    const skip = (el) => {
      const t = (el.type || "").toLowerCase();
      return (
        t === "file" ||
        t === "password" ||
        t === "hidden" ||
        t === "submit" ||
        t === "button" ||
        el.getAttribute("aria-hidden") === "true"
      );
    };
    const keyOf = (el, i) => el.id || el.name || "f" + i;
    const setNative = (el, val) => {
      try {
        const proto =
          el.tagName === "SELECT"
            ? window.HTMLSelectElement.prototype
            : el.tagName === "TEXTAREA"
            ? window.HTMLTextAreaElement.prototype
            : window.HTMLInputElement.prototype;
        const dd = Object.getOwnPropertyDescriptor(proto, "value");
        if (dd && dd.set) dd.set.call(el, val);
        else el.value = val;
      } catch (e) {
        el.value = val;
      }
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    };
    const collect = () => {
      const data = {};
      root.querySelectorAll(SEL).forEach((el, i) => {
        if (skip(el)) return;
        const k = keyOf(el, i);
        if (el.type === "checkbox" || el.type === "radio") data[k] = el.checked;
        else data[k] = el.value;
      });
      return data;
    };
    const restoreFrom = (data) => {
      if (!data || typeof data !== "object") return;
      root.querySelectorAll(SEL).forEach((el, i) => {
        if (skip(el)) return;
        const k = keyOf(el, i);
        if (!(k in data)) return;
        if (el.type === "checkbox" || el.type === "radio") {
          if (!!el.checked !== !!data[k]) el.click();
        } else if (data[k] != null && data[k] !== "") {
          setNative(el, data[k]);
        }
      });
    };
    const inDraft = () => draftRef.current && draftRef.current.id && draftRef.current.token;
    const saveLocal = () => {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(collect()));
      } catch (e) {}
    };
    const saveServer = () => {
      try {
        fetch(API + "/api/draft/save", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: draftRef.current.id,
            t: draftRef.current.token,
            data: collect(),
          }),
        });
      } catch (e) {}
    };
    const save = () => {
      if (inDraft()) saveServer();
      else saveLocal();
    };
    const restore = () => {
      if (inDraft() && draft && draft.data) {
        restoreFrom(draft.data);
        return;
      }
      let data = {};
      try {
        data = JSON.parse(window.localStorage.getItem(KEY) || "{}");
      } catch (e) {}
      restoreFrom(data);
    };
    let saveTimer;
    const onInput = () => {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(save, 700);
    };
    const onSubmit = () => {
      if (!inDraft()) {
        try {
          window.localStorage.removeItem(KEY);
        } catch (e) {}
      }
    };
    const t = setTimeout(restore, 500);
    root.addEventListener("input", onInput, true);
    root.addEventListener("change", onInput, true);
    root.addEventListener("submit", onSubmit, true);
    return () => {
      clearTimeout(t);
      clearTimeout(saveTimer);
      root.removeEventListener("input", onInput, true);
      root.removeEventListener("change", onInput, true);
      root.removeEventListener("submit", onSubmit, true);
    };
  }, [ok, draft]);

  async function submitCode(e) {
    e.preventDefault();
    if (!code.trim()) return;
    setCodeBusy(true);
    setCodeErr(false);
    const valid = await verifyCode(code.trim());
    setCodeBusy(false);
    if (valid) unlock();
    else setCodeErr(true);
  }

  function upd(k, v) {
    setForm((f) => Object.assign({}, f, { [k]: v }));
  }

  async function submitIntro(e) {
    e.preventDefault();
    /* honeypot check removed: browser autofill was filling the hidden field and silently blocking real submissions */
    var _gf = e.currentTarget || e.target;
    var _gi = _gf ? _gf.querySelectorAll("input") : [];
    var _gt = _gf ? _gf.querySelector("textarea") : null;
    var _nm = _gi[1] ? _gi[1].value : (form.name || "");
    var _cp = _gi[2] ? _gi[2].value : (form.company || "");
    var _em = _gi[3] ? _gi[3].value : (form.email || "");
    var _nd = _gt ? _gt.value : ("Enquiry via " + (window.location.pathname.split("/").filter(Boolean).pop() || "partner") + " form");
    if (!_nm.trim() || !validEmail(_em)) {
      setErr("Please enter your name and a valid work email.");
      return;
    }
    setBusy(true);
    setErr("");
    try {
      const r = await fetch(API + "/api/request-access", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: _nm.trim(),
          company: _cp.trim(),
          email: _em.trim(),
          need: _nd.trim(),
        slug: (window.location.pathname.split("/").filter(Boolean).pop() || ""),
        }),
      });
      const d = await r.json();
      if (d && d.ok) setSent(true);
      else setErr((d && d.error) || "Something went wrong. Please try again.");
    } catch (e2) {
      setErr("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  async function submitJoin(e) {
    e.preventDefault();
    const name = joinForm.name.trim();
    const email = joinForm.email.trim();
    if (!name || !validEmail(email)) {
      setJoinErr("Please enter your name and a valid work email.");
      return;
    }
    setJoinBusy(true);
    setJoinErr("");
    try {
      const r = await fetch(API + "/api/draft/join", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: draftId, t: draftToken, name: name, email: email }),
      });
      const dj = await r.json();
      if (dj && dj.ok) {
        setMe({ name: name, email: email });
        setDraft(dj);
        setShareUrl(
          window.location.origin + "/partner/" + dj.slug + "?draft=" + draftId + "&t=" + draftToken
        );
        setJoinNeeded(false);
        unlock();
      } else {
        setJoinErr((dj && dj.error) || "Could not open this form.");
      }
    } catch (e2) {
      setJoinErr("Something went wrong. Please try again.");
    } finally {
      setJoinBusy(false);
    }
  }

  async function createShare(e) {
    e.preventDefault();
    const name = initForm.name.trim();
    const email = initForm.email.trim();
    if (!name || !validEmail(email)) {
      setErr("Enter your name and a valid work email to share.");
      return;
    }
    setBusy(true);
    setErr("");
    try {
      const r = await fetch(API + "/api/draft/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ slug: slugFromPath(), name: name, email: email }),
      });
      const dj = await r.json();
      if (dj && dj.ok) {
        setDraftId(dj.id);
        setDraftToken(dj.token);
        draftRef.current = { id: dj.id, token: dj.token };
        setShareUrl(dj.url);
        setMe({ name: name, email: email });
        const data = collectNow();
        setDraft({
          slug: slugFromPath(),
          label: "",
          data: data,
          contributors: [{ name: name, email: email }],
          domain: domainOf(email),
          status: "open",
        });
        try {
          await fetch(API + "/api/draft/save", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: dj.id, t: dj.token, data: data }),
          });
        } catch (e3) {}
        try {
          window.history.replaceState(
            null,
            "",
            window.location.pathname + "?draft=" + dj.id + "&t=" + dj.token
          );
        } catch (e4) {}
      } else {
        setErr((dj && dj.error) || "Could not create a shareable link.");
      }
    } catch (e2) {
      setErr("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  async function sendInvite(e) {
    e.preventDefault();
    const email = inviteEmail.trim();
    if (!validEmail(email)) {
      setInviteMsg("Enter a valid work email.");
      return;
    }
    setInviteMsg("Sending...");
    try {
      const r = await fetch(API + "/api/draft/invite", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: draftId,
          t: draftToken,
          name: me ? me.name : "",
          email: email,
        }),
      });
      const dj = await r.json();
      if (dj && dj.ok) {
        setInviteMsg("Invitation sent to " + email);
        setInviteEmail("");
      } else {
        setInviteMsg((dj && dj.error) || "Could not send the invitation.");
      }
    } catch (e2) {
      setInviteMsg("Something went wrong. Please try again.");
    }
  }

  function copyLink() {
    try {
      window.navigator.clipboard.writeText(shareUrl);
      setCopyMsg("Copied");
      setTimeout(() => setCopyMsg(""), 1500);
    } catch (e) {
      setCopyMsg("Select the link and copy it");
    }
  }

  const card = {
    maxWidth: 560,
    margin: "48px auto",
    padding: "36px 32px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
    color: "#1f2937",
  };
  const inputStyle = {
    width: "100%",
    padding: "11px 13px",
    marginTop: 6,
    border: "1px solid #d1d5db",
    borderRadius: 8,
    fontSize: 15,
    boxSizing: "border-box",
  };
  const labelStyle = { display: "block", marginTop: 14, fontSize: 13, fontWeight: 600, color: "#374151" };
  const btn = {
    marginTop: 20,
    width: "100%",
    padding: "12px 16px",
    background: "#ea580c",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
  };

  const wrap = (inner) => <div style={card}>{inner}</div>;

  // Collaborator opening a shared draft link: capture identity first.
  if (joinNeeded) {
    return wrap(
      <div>
        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.6, color: "#0d9488", textTransform: "uppercase" }}>
          You have been invited
        </div>
        <h1 style={{ fontSize: 22, margin: "8px 0 6px" }}>Help complete this form</h1>
        <p style={{ fontSize: 14, color: "#4b5563", lineHeight: 1.5 }}>
          A colleague shared this LAMKO form with you so you can help fill it in. Enter your name and
          work email to continue. Everything you type saves automatically.
        </p>
        <form onSubmit={submitJoin}>
          <label style={labelStyle}>Your name</label>
          <input
            style={inputStyle}
            value={joinForm.name}
            onChange={(e) => setJoinForm(Object.assign({}, joinForm, { name: e.target.value }))}
          />
          <label style={labelStyle}>Your work email</label>
          <input
            style={inputStyle}
            value={joinForm.email}
            onChange={(e) => setJoinForm(Object.assign({}, joinForm, { email: e.target.value }))}
          />
          {joinErr ? <p style={{ color: "#b91c1c", fontSize: 13, marginTop: 10 }}>{joinErr}</p> : null}
          <button type="submit" style={btn} disabled={joinBusy}>
            {joinBusy ? "Opening..." : "Open the form"}
          </button>
        </form>
      </div>
    );
  }

  if (checking) {
    return wrap(<p style={{ textAlign: "center", color: "#6b7280" }}>Verifying your access...</p>);
  }

  if (sent) {
    return wrap(
      <div>
        <h1 style={{ fontSize: 22, margin: "0 0 8px" }}>Thank you</h1>
        <p style={{ fontSize: 15, color: "#4b5563", lineHeight: 1.6 }}>
          Your request has reached the LAMKO team. We review each one personally and will email you a
          secure link to open this form shortly.
        </p>
      </div>
    );
  }

  if (ok) {
    const domain = draft ? draft.domain : "";
    const contributors = draft && draft.contributors ? draft.contributors : [];
    return (
      <div>
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto 4px",
            padding: "14px 16px",
            background: "#f8fafc",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            fontSize: 14,
            color: "#334155",
          }}
        >
          {!draftId ? (
            !showShare ? (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                <span>Need input from colleagues before you submit?</span>
                <button
                  onClick={() => setShowShare(true)}
                  style={{ padding: "8px 14px", background: "#0d9488", color: "#fff", border: "none", borderRadius: 7, fontWeight: 600, cursor: "pointer" }}
                >
                  Save and share
                </button>
              </div>
            ) : (
              <form onSubmit={createShare} style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "flex-end" }}>
                <div style={{ flex: "1 1 100%" }}>
                  Create a private link your colleagues can use to help complete this form. It stays
                  within your company and expires in 30 days.
                </div>
                <input
                  style={{ flex: "1 1 180px", padding: "9px 11px", border: "1px solid #d1d5db", borderRadius: 7 }}
                  placeholder="Your name"
                  value={initForm.name}
                  onChange={(e) => setInitForm(Object.assign({}, initForm, { name: e.target.value }))}
                />
                <input
                  style={{ flex: "1 1 200px", padding: "9px 11px", border: "1px solid #d1d5db", borderRadius: 7 }}
                  placeholder="Your work email"
                  value={initForm.email}
                  onChange={(e) => setInitForm(Object.assign({}, initForm, { email: e.target.value }))}
                />
                <button
                  type="submit"
                  disabled={busy}
                  style={{ padding: "9px 16px", background: "#ea580c", color: "#fff", border: "none", borderRadius: 7, fontWeight: 600, cursor: "pointer" }}
                >
                  {busy ? "Creating..." : "Create link"}
                </button>
                {err ? <div style={{ flex: "1 1 100%", color: "#b91c1c", fontSize: 13 }}>{err}</div> : null}
              </form>
            )
          ) : (
            <div>
              <div style={{ fontWeight: 600, color: "#0f766e" }}>
                Collaborative form{domain ? " · private to " + domain : ""}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", marginTop: 8 }}>
                <input
                  readOnly
                  value={shareUrl}
                  onFocus={(e) => e.target.select()}
                  style={{ flex: "1 1 260px", padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 7, fontSize: 13, color: "#475569" }}
                />
                <button
                  onClick={copyLink}
                  style={{ padding: "8px 14px", background: "#0d9488", color: "#fff", border: "none", borderRadius: 7, fontWeight: 600, cursor: "pointer" }}
                >
                  {copyMsg || "Copy link"}
                </button>
              </div>
              <form onSubmit={sendInvite} style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", marginTop: 8 }}>
                <input
                  value={inviteEmail}
                  onChange={(e) => setInviteEmail(e.target.value)}
                  placeholder={domain ? "colleague@" + domain : "colleague email"}
                  style={{ flex: "1 1 260px", padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 7, fontSize: 13 }}
                />
                <button
                  type="submit"
                  style={{ padding: "8px 14px", background: "#334155", color: "#fff", border: "none", borderRadius: 7, fontWeight: 600, cursor: "pointer" }}
                >
                  Send invite
                </button>
              </form>
              {inviteMsg ? <div style={{ fontSize: 13, color: "#475569", marginTop: 6 }}>{inviteMsg}</div> : null}
              {contributors.length ? (
                <div style={{ fontSize: 13, color: "#64748b", marginTop: 8 }}>
                  Contributors: {contributors.map((c) => c.name).join(", ")}
                </div>
              ) : null}
            </div>
          )}
        </div>
        <div ref={boxRef}><CollabToolbar position="top" />{children}{(window.location.pathname||"").indexOf("become-partner") !== -1 ? <PartnerCatalog /> : null}
          <CollabToolbar position="bottom" /></div>
      </div>
    );
  }

  return wrap(
    <div>
      <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.6, color: "#ea580c", textTransform: "uppercase" }}>
        Partner access
      </div>
      <h1 style={{ fontSize: 22, margin: "8px 0 6px" }}>Request access to this form</h1>
      <p style={{ fontSize: 14, color: "#4b5563", lineHeight: 1.5 }}>
        Tell us a little about you and what you are looking for. We review each request personally and
        email you a secure link to open the form.
      </p>
      <p style={{ fontSize: 13, color: "#b45309", marginTop: 6, marginBottom: 6 }}>If this button does not respond, please type your details instead of using browser autofill.</p>
      <div style={{ marginBottom: 16 }}><CdaCallout from={window.location.pathname} /></div>
      <GateIntro />
          <form onSubmit={submitIntro}>
        <input
          style={{ position: "absolute", left: "-9999px" }}
          tabIndex={-1}
          autoComplete="off"
          value={form.hp}
          onChange={(e) => upd("hp", e.target.value)}
        />
        <label style={labelStyle}>Name</label>
        <input style={inputStyle} value={form.name} onChange={(e) => upd("name", e.target.value)} />
        <label style={labelStyle}>Company</label>
        <input style={inputStyle} value={form.company} onChange={(e) => upd("company", e.target.value)} />
        <label style={labelStyle}>Work email</label>
        <input style={inputStyle} value={form.email} onChange={(e) => upd("email", e.target.value)} />
        
        {err ? <p style={{ color: "#b91c1c", fontSize: 13, marginTop: 10 }}>{err}</p> : null}
        <button type="submit" style={btn} disabled={busy}>
          {busy ? "Sending..." : "Request access"}
        </button>
      </form>
      <div style={{ marginTop: 18, textAlign: "center" }}>
        {!showCode ? (
          <button
            onClick={() => setShowCode(true)}
            style={{ background: "none", border: "none", color: "#0d9488", fontSize: 13, cursor: "pointer", textDecoration: "underline" }}
          >
            I already have an access code
          </button>
        ) : (
          <form onSubmit={submitCode} style={{ marginTop: 6 }}>
            <input
              style={inputStyle}
              placeholder="Enter your access code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            {codeErr ? <p style={{ color: "#b91c1c", fontSize: 13, marginTop: 8 }}>That code was not recognized.</p> : null}
            <button type="submit" style={Object.assign({}, btn, { background: "#0d9488" })} disabled={codeBusy}>
              {codeBusy ? "Checking..." : "Open the form"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default FormGate;
